// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1yVxN","col":"styles_col__5YF_V"};